<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { is_gen_1, is_gen_2, isWallDisplay } from 'src/helpers/interface_helpers';
	//Stores
	import { updating_devices } from 'src/stores/device-runtime/process';
	import { cloud_disabled_devices } from 'src/stores/device-runtime/firmware-ui';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	//Design system components
	import { Loader, ProgressBar, Text, CircleAvatar } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { getDeviceAvatarDefaultConfig } from 'src/helpers/device_state_view_helpers';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let isV2Component: boolean = false;

	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;

	const getProgressMessage = (progress) => {
		if (progress >= 0 && progress < 25) {
			return $format('progress_state_initializing_update', {
				default: 'initializing update',
			});
		} else if (progress >= 25 && progress < 50) {
			return $format('progress_state_downloading_update', {
				default: 'downloading update',
			});
		} else if (progress >= 50 && progress < 75) {
			return $format('progress_state_installing_update', {
				default: 'installing update',
			});
		} else if (progress >= 75 && progress < 95) {
			return $format('progress_state_configuring', {
				default: 'Configuration',
			});
		} else if (progress >= 95 && progress < 100) {
			return $format('progress_state_finalizing_update', {
				default: 'Finalizing',
			});
		}
	};

	const isGen1 = is_gen_1(device);

	$: fwUpdateProgress =
		$updating_devices?.[device.id]?.prog === undefined ? 101 : $updating_devices?.[device.id]?.prog;

	$: nonWallDisplayProgressText =
		fwUpdateProgress >= 100
			? $format('progress_state_update_complete', {
					default: 'Firmware update complete',
				})
			: getProgressMessage(fwUpdateProgress) + '...';

	$: progressStatusText = isWallDisplay(device?.type)
		? $format('progress_state_downloading_update', {
				default: 'downloading update',
			}) + '...'
		: nonWallDisplayProgressText;
</script>

<CircleAvatar
	{...getDeviceAvatarDefaultConfig(device)}
	borderStatus={fwUpdateProgress >= 100 && !isWallDisplay(device?.type) && !isGen1
		? { icon: 'fa-solid fa-check', color: 'color-success' }
		: null}
/>

{#if is_gen_2(device) && typeof $cloud_disabled_devices[device.id] === 'undefined'}
	<Text class="mb-m text-bold text-center">
		{capFirstChar(progressStatusText)}
	</Text>
	<div class={isV2Component === true ? 'pl-m pr-m' : undefined}>
		<ProgressBar
			class="width-full mb-s"
			type={fwUpdateProgress > 100 && !isWallDisplay(device?.type) ? 'success' : 'primary'}
			progress={fwUpdateProgress}
		/>
	</div>
	<Text class="text-color-muted text-center mb-s" styleType="body-small"
		>{$format('progress_state_percent_complete', {
			default: `${fwUpdateProgress >= 100 ? 100 : fwUpdateProgress}% Complete`,
			values: {
				progress: fwUpdateProgress >= 100 ? 100 : fwUpdateProgress,
			},
		})}
	</Text>
	<ProgressBar
		class="width-full"
		type={fwUpdateProgress >= 100 ? 'success' : 'primary'}
		progress={fwUpdateProgress}
	/>
{:else}
	<Text class="mb-s text-bold text-center">
		{$format(deviceState?.description?.value)}
	</Text>
	{#if fwUpdateProgress < 100}
		<Loader class="mb-s" />
	{/if}
{/if}
